export const Columns = [
  {
    label: 'Display name',
    width: '200px'
  },
  {
    label: 'Attribute type',
    width: '100px'
  },
  {
    label: 'Preview',
    width: '160px'
  },
  {
    label: 'Show in conversation',
    width: '160px'
  },
  {
    width: '30px'
  }
]

export const SourcedColumns = [
  {
    label: 'Display name',
    width: '200px'
  },
  {
    label: 'Sourced from',
    width: '150px'
  },
  {
    label: 'Attribute type',
    width: '60px'
  },
  {
    label: 'Show in conversation',
    width: '100px'
  },
  {
    width: '30px'
  }
]

export const ATTRIBUTE_STATUS = Object.freeze({
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
  ARCHIVED: "HIDDEN",
})
